
export enum PaymentType {
    Dividend = 1,
    Capital = 2,
}